export default __webpack_public_path__ + "static/media/TGLabsLogo.e528e23a.svg";